import { PixelsPerInch } from 'pdfjs-dist';

/**
 * This method returns pdf scale that should be applied to a document taking into account display's pixels per inch
 */
export const getRealPDFScale = (pdfScale: number) => pdfScale * PixelsPerInch.PDF_TO_CSS_UNITS;
